import { List } from "immutable";

export default {
  points: List(),
  plot: {},
  editMode: 0
}
